module.exports = __webpack_public_path__ + "img/icons8-team-r-enAOPw8Rs-unsplash.adbdda55.jpg";